export default __webpack_public_path__ + "static/media/find-icon.45779b97.svg";